// import { CAUI, LoadSpinner } from 'ca-ui';
import { CAUI, LoadSpinner } from '../../ui/2.0/ca-ui';
import { VRControls } from './controls.js';
import { VREditor } from './ver-editor/editor.js';
import { VRScene } from './scene.js';
import { Scene } from '../../third-party/webxr/render/scenes/scene.js';
import { Renderer } from '../../third-party/webxr/render/core/renderer.js';
import { VRInsetMap } from './inset-map.js';
import { VRContentView } from './content-view';
import { VRWelcomePopup } from './welcome-popup';

import { PanoviewerOperations } from './operations/panoviewer_ops.js';
import { SceneOperations } from './operations/scene_ops';
import { UndoRedo } from './ver-editor/undo-redo';

export class VirtualRoom {
    static ZOOM_INCREMENT = 35;
    constructor (wrapper, options, forceEditMode) {
      this.pvOps = new PanoviewerOperations();
      this.sceneOps = new SceneOperations();
      this.contentId = options.contentId;
      this.wrapper = wrapper;
      this.wrapper.css('overflow', 'hidden');

      this.container = $('<div class="ca-vr_container"></div>');
      // wrapper.append(this.container);
      this.wrapper.append(this.container);

      this.contentView = new VRContentView(this, {
        onClose: () => this.unFocus()
      });
      this.container.append(this.contentView.el);

      this.startTitle = document.title;

      this.loadSpinner = new LoadSpinner();
      this.container.append(this.loadSpinner.el);

      this.pitch = 0;
      this.yaw = 0;
      this.roll = 0;
      this.hfov = 30;
      this.vrMode = false;
      this.ready = false;
      this.scenes = [];
      this.showingWelcome = null;

      // hotspot vars - default them
      this.isHotspotClicked = false;
      this.currentHotspotVerticalPos = 0;
      this.currentHotspotHorizontalPos = 0;
      this.currentHotspotYaw = 0;
      this.currentHotspotPitch = 0;

      if (!this.undoRedo) {
        this.undoRedo = new UndoRedo(this);
      }

      // set if local development environment
      // this is hacky but if it works, it works
      if (window.location.search.includes('dev=true') || window.location.search.includes('communityanalytics.local')) {
        this.localDev = true;
      }

      // add preserveDrawingBuffer
      HTMLCanvasElement.prototype.getContext = (function (origFn) {
        return function (type, attributes) {
          if (type === 'webgl') {
            attributes = Object.assign({}, attributes, { preserveDrawingBuffer: true });
          }
          return origFn.call(this, type, attributes);
        };
      })(HTMLCanvasElement.prototype.getContext);

      this.loadAssets(function (assets) {
        this.assets = assets;

        if (this.localDev) {
          this.initEditor();
        }
        if (options.caEditor) { this.initEditor(); } else {
          if (options === undefined) {
            this.init(JSON.parse(window.localStorage.getItem('ver_config')), forceEditMode);
          } else if (typeof options === 'string') {
            $.ajax(options).done(function (opts) {
              this.init(opts, forceEditMode);
            }.bind(this)).fail(function () {
              alert('error');
            });
          } else { this.init(options, forceEditMode); }
        }
      }.bind(this));
      window.vr = this;

      // get custom permissions from ios based devices
      // if device is ios
      this.container.on('click', function () {
        if (typeof (DeviceMotionEvent) !== 'undefined' && typeof (DeviceMotionEvent.requestPermission) === 'function') {
          DeviceMotionEvent.requestPermission().then(response => {
            if (response === 'granted') {
              this.panoViewer.setGyroMode('yawPitch');
            }
          });
        }
      }.bind(this));
    }

    hotspotClicked (yaw, pitch) {
      this.isHotspotClicked = true;

      const yawToPx = this.yawPitchToPx(yaw, pitch);
      const vertical = yawToPx.y;
      const horizontal = yawToPx.x;

      this.currentHotspotVerticalPos = vertical; // yaw
      this.currentHotspotHorizontalPos = horizontal; // pitch
      this.currentHotspotYaw = yaw;
      this.currentHotspotPitch = pitch;
    }

    init (options, forceEditMode) {
      if (options.data !== undefined && options.data.metadata) {
        this.options = $.extend({}, VirtualRoom.getDefaultOptions(), options.data.metadata);
      } else {
        this.options = $.extend({}, VirtualRoom.getDefaultOptions(), options);
      }

      if (forceEditMode) { this.options.editor = true; }

      this.initOptions();
      this.injectStyles();

      if (this.options.caEditor && this.editor !== undefined) {
        this.editor.init(this.options);
        $(document.body).addClass('ca-vr-caeditorembed');
      }

      // if(this.options.editor == true) this.initEditor();

      if (this.options.translation) { this.initTranslation(); }

      // if options showHotspotListMenuButton

      if (this.options.logo) {
        this.clientLogo = $('<img class="ca-vr_clientlogo" src="' + this.options.logo + '">');
        this.container.append(this.clientLogo);
      }

      if (this.options.branding !== undefined) {
        if (this.options.branding.logo !== null) {
          this.clientLogo = $(`<img class="ca-vr_clientlogo" src="${this.options.branding.logo}">`);
          this.container.append(this.clientLogo);
        }
      }

      // call this from the the panoviewer operations

      // we can pass "equirectangular" to force the correct rendering option
      this.panoViewer = this.pvOps.constructPanoviewer(this.container[0], this.yaw, this.pitch, this.options.startFov, 'yawPitch', !this.options.mobile);

      // Nav map
      if (this.options.navigationMap) {
        const mapOpts = $.extend({
          fov: this.getYaw(),
          hotspots: [],
          onHotspotClick: function (id) {
            this.loadScene(id);
          }.bind(this)
        }, this.options.navigationMap);
        mapOpts.media = this.parseMediaUrl(mapOpts.media);

        this.options.scenes.forEach(function (s) {
          if (s.mapPosition) {
            mapOpts.hotspots.push({
              id: s.id,
              position: {
                x: s.mapPosition.x,
                y: s.mapPosition.y
              },
              fov: s.mapPosition.fov
            });
          }
        });

        this.insetMap = new VRInsetMap(mapOpts);
        this.insetMap.hide();
        this.container.append(this.insetMap.el);
      }

      if (this.options.firstScene) {
        this.loadScene(this.options.firstScene);
      } else {
        this.loadScene(this.options.scenes[0]);
      }

      this.panoViewer.on('animationEnd', function () {});

      this.panoViewer.on('error', function (e) {
        console.error(e.message);
      });

      // mark as EVENT BINDING
      this.panoViewer.on('ready', function () { // panoViewer creates new canvas to work with
        this.canvas = $(this.panoViewer._photoSphereRenderer.canvas);

        this.canvas.addClass('ca-vr_canvas');
        if (this.editor) {
          this.editor.setScene(this.scene);
        }

        if (this.clientLogo != null && options.logoWhite !== false) {
          this.clientLogo.addClass('ca-vr_clientlogo_white');
        }

        if (!this.ready) {
          this.onReady();
        }
        this.onLoaded();
      }.bind(this));

      // mark as EVENT BINDING
      this.panoViewer.on('viewChange', function () {
        const bounds = this.canvas[0].getBoundingClientRect();

        const tl = this.pxToYawPitch(-bounds.left, -bounds.top, true);
        const br = this.pxToYawPitch(this.container.width() - bounds.left, this.container.height() - bounds.top, true);

        this.topLeftYawPitch = {
          yaw: Math.min(tl.yaw, br.yaw),
          pitch: Math.min(tl.pitch, br.pitch)
        };
        this.bottomRightYawPitch = {
          yaw: Math.max(tl.yaw, br.yaw),
          pitch: Math.max(tl.pitch, br.pitch)
        };

        if (this.yawLines) {
          this.yawLines.forEach(function (l, index) {
            const yaw = index * 10;
            const px = this.yawPitchToPx(index * 10, 0);
            l.css('left', px.x);
            l.css('opacity', yaw > this.topLeftYawPitch.yaw ? 0 : 1);
          }.bind(this));
        }
        if (this.pitchLines) {
          this.pitchLines.forEach(function (l, index) {
            const px = this.yawPitchToPx(0, index * 10);
            l.css('top', px.y);
          }.bind(this));
        }

        if (this.insetMap) { this.insetMap.setFov(-this.getYaw()); }

        this.scene.render();
      }.bind(this));

      // mark as EVENT BINDING
      this.panoViewer.on('renderingContextLost', function () {
        alert('renderingContextLost');
      });

      // mark as EVENT BINDING
      this.container.on('mousedown', function (e) {
        this.stopAutoRotate();
        this.mousedown = true;
        this.mousedownStartX = e.clientX;
        this.mousedownStartY = e.clientY;

        if (this.showingWelcome) { this.hideWelcome(); }
      }.bind(this));

      // mark as EVENT BINDING
      this.container.on('mousemove', function (e) {
        if (!this.moving && this.mousedown && (e.clientX !== this.mousedownStartX || e.clientY !== this.mousedownStartY)) {
          this.moving = true;
          this.container.addClass('ca-vr_moving');
          this.scene.onStartMoving();
        }
      }.bind(this));

      // mark as EVENT BINDING
      this.container.on('mouseup', function () {
        this.mousedown = false;
        this.moving = false;
        this.container.removeClass('ca-vr_moving');
        this.scene.onStopMoving();
      }.bind(this));

      // mark as EVENT BINDING
      this.container.on('click', function () {});

      // mark as EVENT BINDING
      $(window).on('resize', function () {
        this.onResize();
      }.bind(this));
    }

    onReady () {
      if (this.ready) { return; }

      this.ready = true;
      this.controls = new VRControls(this, this.options);
      this.container.append(this.controls.el);

      if (this.editor) {
        this.options.navigationMap = {
          showPerson: true,
          showRoomLayout: true
        };

        if (this.options.caEditor) {
          setTimeout(function () {
            this.openEditor(true);
          }.bind(this), 500);
        }
      }

      this.showControls(true);
      if (this.options.interestRegions !== undefined && this.options.interestRegions !== null) {
        this.addTopBarInterestRegionMenu();
        this.addHotspotListMenu();
      }
      // window.requestAnimationFrame(this.render.bind(this));
    }

    /* render(t)
    {
        window.requestAnimationFrame(this.render.bind(this));

        if(this.scene) this.scene.render();
    } */

    showWelcome () {
      if (!this.options.showWelcome) {
        return;
      }
      if (this.options.welcomeContent !== undefined) {
        if (this.options.welcomeContent.metadata.length === 0 && this.options.welcomeContent.contentToUse) {
          return;
        }
        this.welcome = new VRWelcomePopup(this, this.options.welcomeContent, this.options.welcomePerson);
        this.scene.container.append(this.welcome.el);
        this.welcome.open();
        this.showControls(false);
        this.panoViewer.setUseZoom(false);
        this.showingWelcome = true;
        this.container.addClass('ca-vr--welcoming');
        this.scene.showWelcome(this.welcome);
      }
    }

    hideWelcome () {
      if (!this.options.showWelcome) { return; }

      this.showControls(true);
      this.panoViewer.setUseZoom(true);
      this.container.removeClass('ca-vr--welcoming');
      this.scene.hideWelcome();
      this.welcome.close();
      this.showingWelcome = false;
    }

    update () {
      if (this.panoViewer) {
        this.panoViewer.trigger('viewChange');
        this.panoViewer.updateViewportDimensions();

        this.canvasWidth = this.container.width();
        this.canvasHeight = this.container.height();
      }

      if (this.welcome) { this.welcome.layout(); }

      if (this.scene) { this.scene.layout(); }
    }

    onResize () {
      this.update();
    }

    getCurrentScene () {
      return this.scene;
    }

    getScene (id) {
      // not sure why content only saves to a "new scene" entry and leaves the old one empty
      // needs more investigation
      if (!id) { return this.options.scenes[1]; }

      const scenes = this.options.scenes.filter((s) => s.id === id);
      if (scenes.length === 1) { return scenes[0]; }

      return null;
    }

    loadScene (scene, yaw, pitch) {
      const sceneOpts = this.getScene(scene) ? this.getScene(scene) : typeof scene !== 'object' ? scene.isInteger() : scene;
      if (sceneOpts) {
        this.logAction('Scene', 'Loading scene ' + sceneOpts.name);
      }

      this.showLoading();

      if (this.scene) {
        this.previousScene = this.scene;
        this.previousScene.container.hide();
      }

      this.scene = new VRScene(this, sceneOpts);
      this.scenes.push(this.scene);
      this.container.append(this.scene.container);

      if (this.editor) { this.editor.setScene(this.scene); }

      if (this.xrScene) { this.scene.initXR(this.renderer, this.xrScene); }

      this.scene.loadImage(null, yaw, pitch);
    }

    // new logic for loading scenes in VR/XR
    loadSceneXR (scene) {
      const newSceneData = this.getScene(scene);

      // @TODO: VR Loading Widget
      // show loading needs to have a new way to show loading in vr
      this.scene.loadImageXR(newSceneData.media);
    }

    showLoading (label) {
      this.loadSpinner.setLabel(label);
      this.loadSpinner.show();
    }

    hideLoading () {
      this.loadSpinner.hide();
    }

    onLoaded () {
      this.scene.onLoaded();
      this.hideLoading();
      this.update();
      if (this.editor) {
        this.editor.setScene(this.scene);
        this.clientLogo.hide();
      }

      // Nav map
      if (this.insetMap) { this.insetMap.setActiveHotspot(this.scene.options.id); }

      if (this.options.welcomeContent !== null) {
        this.showWelcome();
      }
    }

    getContainer () {
      return this.container;
    }

    getCanvas () {
      return this.canvas;
    }

    initEditor () {
      if (this.editor) { return; }

      this.editor = new VREditor(this);
    }

    getEditor () {
      return this.editor;
    }

    hasEditor () {
      return this.editor != null;
    }

    isEditing () {
      return this.editor && this.editor.isEditing();
    }

    openEditor (open) {
      this.editor.openPanel(open);
    }

    toggleEditor () {
      this.editor.togglePanel();
      // remove disabled-in-editor class from all ca-vr_action-links
      const actionLinks = $('.ca-vr_action-link');
      if (this.insetMap) {
        // this.insetMap.expand(this.editor.isEditing());
      }

      if (!this.isEditing()) {
        actionLinks.each(function (index) {
          $(actionLinks[index]).removeClass('disabled-in-editor');
        });
        if (this.options.showHotspotList) {
          if (this.hotspotListMenu) {
            this.hotspotListMenu.show();
          }
        } else {
          if (this.hotspotListMenu) {
            this.hotspotListMenu.hide();
          }
        }

        if (this.options.showTopBar && this.topBarInterestRegionsMenu !== undefined) {
          if (this.topBarInterestRegionsMenu) {
            this.topBarInterestRegionsMenu.show();
          }
        } else {
          if (this.topBarInterestRegionsMenu) {
            this.topBarInterestRegionsMenu.hide();
          }
        }

        if (this.clientLogo) {
          this.clientLogo.show();
        }

        $('.ca-vr_editortoolbar').hide();
      } else {
        if (this.topBarInterestRegionsMenu) {
          this.topBarInterestRegionsMenu.hide();
        }

        if (this.hotspotListMenu) {
          this.hotspotListMenu.hide();
        }

        if (this.clientLogo) {
          this.clientLogo.hide();
        }

        $('.ca-vr_editortoolbar').show();
      }

      this.scene.hotspots.forEach((hotspot) => {
        if (hotspot.options.tooltip.displayType !== 'always') {
          hotspot.toggleTooltipVisibility(this.isEditing());
        }
      });
    }

    isVrSupported () {
      return this.panoViewer.isWebGLAvailable();
    }

    startAutoRotate () {
      // this.container.addClass('ca-vr_autorotate');
      // this.enable();
      // this.panoViewer.lookAt({ yaw: this.panoViewer.getYaw()+1000}, 2000000);
    }

    // we need to track where this has been called
    stopAutoRotate () {
      this.container.removeClass('ca-vr_autorotate');
      this.panoViewer.lookAt({
        yaw: this.panoViewer.getYaw()
      }, 0);
    }

    toggleDayNight () {
      this.options.isNight = !this.options.isNight;
      this.container.toggleClass('ca-vr_nightmode', this.options.isNight);
      this.scene.toggleDayNight();

      // Nav map
      if (this.insetMap) {
        this.insetMap.setMedia(this.parseMediaUrl(this.options.navigationMap.media));
      }
    }

    initOptions () {
      if (!this.options.controlColor) { this.options.controlColor = 'white'; }

      if (!this.options.controlHoverColor) {
        this.options.controlHoverColor = '#316ae3';
      }
      if (!this.options.hotspotColor) { this.options.hotspotColor = '#007bff'; }

      if (!this.options.hotspotHoverColor) {
        this.options.hotspotHoverColor = '#007bff';
      }
      if (!this.options.hotspotHoverTextColor) {
        this.options.hotspotHoverTextColor = '#007bff';
      }
      if (!this.options.hotspotTextColor) { this.options.hotspotTextColor = 'white'; }

      if (!this.options.hotspotTooltipColor) {
        this.options.hotspotTooltipColor = 'white';
      }
      if (!this.options.hotspotTooltipTextColor) {
        this.options.hotspotTooltipTextColor = '#007bff';
      }
      if (!this.options.mediaVersion) { this.options.mediaVersion = '1'; }

      if (this.options.modal === undefined) { this.options.modal = false; }

      if (!this.options.modalHeadingColor) {
        this.options.modalHeadingColor = '#316ae3';
      }
      if (!this.options.buttonPrimaryColor) {
        this.options.buttonPrimaryColor = '#316ae3';
      }
      if (!this.options.modalBgColor) {
        this.options.modalBgColor = 'rgb(255,255,255 / 18%)';
      }
      if (!this.options.controlPosition) { this.options.controlPosition = 'top'; }

      if (!this.options.controls) { this.options.controls = 'all'; }

      if (!this.options.mediaVersion) { this.options.mediaVersion = '1.0.0'; }

      if (this.options.dayNight === undefined) { this.options.dayNight = true; }

      if (window.location.search.includes('edit=true')) {
        this.options.editor = true;
      }
      if (window.location.search.includes('dev=true')) {
        this.options.devMode = true;
      }

      this.options.allControls = this.options.controls === 'all';
      this.options.hasShare = this.options.shareFacebook !== undefined || this.options.shareTwitter !== undefined || this.options.shareLinkedIn !== undefined || this.options.shareYouTube !== undefined || this.options.shareInstagram !== undefined;
      this.options.controlPositionY = this.options.controlPosition.includes('bottom') ? 'bottom' : 'top';

      this.options.mobile = window.matchMedia('only screen and (max-width: 760px)').matches;
      this.options.startFov = this.options.mobile ? 30 : 75;

      const dateNow = new Date($.now());
      this.options.isNight = this.options.nightMode || dateNow.getHours() >= 18;
      this.container.toggleClass('ca-vr_nightmode', this.options.isNight);

      console.log(this.options);
    }

    getStartFov () {
      if (this.options.mobile) {
        return 90;
      } else {
        return this.options.startFov;
      }
      // TODO: create startFovMobile for use in the editor so we don't have to do this work around
    }

    parseMediaUrl (mediaUrl) {
      if (mediaUrl == null) { return null; }

      return mediaUrl.replace('{quality}', this.options.mobile ? 'sd' : 'hd').replace('{daynight}', this.options.isNight ? 'night' : 'day');
    }

    static getDefaultOptions () {
      return {
        scenes: [
          {
            componentName: 'Room',
            media: 'https://ca-v2.s3-ap-southeast-2.amazonaws.com/ca/virtual-editor/assets/rooms/room_lightroom_{daynight}_{quality}.jpg'
          }
        ],
        ambient: true,
        hasMenu: true,
        fullpage: true,
        showPoweredBy: true,
        controls: 'zoom,fullscreen,daynight,ambient,motion',
        allControls: false,
        controlPosition: 'top right',
        editor: true,
        room: 'lightroom',
        translation: false,
        translateLanguages: 'ar,vi,zh-CN'
      };
    }

    showControls (show) {
      this.controls.showControls(show);

      if (this.insetMap) {
        if (show) { this.insetMap.show(); } else { this.insetMap.hide(); }
      }

      if (this.translateSelct) { this.translateSelct.toggle(show); }
    }

    addRemoveControlOption (control, add) {
      if (add) { this.options.controls += ',' + control; } else {
        this.options.controls = this.options.controls.replace(',' + control, '').replace(control, '');
      }
      this.controls.toggleIndividualControl(control, add);
    }

    onXRFrame (time, frame) {
      const renderer = this.panoViewer._photoSphereRenderer;
      const vr = renderer._vr;
      const gl = this.panoViewer._photoSphereRenderer.context;
      if ((this.viewerPosition !== frame.getViewerPose(this.refSpace) && this.refSpace) || (!this.viewerPosition && this.refSpace)) {
        this.viewerPosition = frame.getViewerPose(this.refSpace);
      }

      if (!this.viewerPosition) {
        this.viewerPosition = frame.getViewerPose(this.refSpace);
      }

      this.xrScene.startFrame();
      this.xrFrame = frame;

      this.xrScene.updateInputSources(frame, this.refSpace);

      const eyeParams = vr.getEyeParams(gl, frame);
      if (!eyeParams) { return; }

      const pose = frame.getViewerPose(this.refSpace);
      if (pose) {
        vr.beforeRender(gl, frame);

        this.xrScene.drawXRFrame(frame, pose, function () {
          const shader = renderer.shaderProgram;
          gl.useProgram(shader);

          gl.disable(WebGLRenderingContext.CULL_FACE);
          gl.disable(WebGLRenderingContext.BLEND);
          gl.disable(WebGLRenderingContext.DEPTH_TEST);

          gl.bindTexture(gl.TEXTURE_2D, renderer.texture);

          let eyeIndex = 0;
          // eslint-disable-next-line no-unused-vars
          for (const view of pose.views) {
            const eyeParam = eyeParams[eyeIndex];

            renderer.mvMatrix = eyeParam.mvMatrix;
            renderer.pMatrix = eyeParam.pMatrix;

            gl.viewport(eyeParam.viewport[0], eyeParam.viewport[1], eyeParam.viewport[2], eyeParam.viewport[3]);
            gl.uniform1f(shader.uEye, eyeIndex);

            renderer._bindBuffers();
            renderer._draw();
            eyeIndex++;
          }

          gl.enable(WebGLRenderingContext.CULL_FACE);
          gl.enable(WebGLRenderingContext.BLEND);
          gl.enable(WebGLRenderingContext.DEPTH_TEST);
        });

        vr.afterRender(gl, frame);
      }

      this.xrScene.endFrame();
    }

    toggleVr () {
      if (!this.vrMode) {
        this.panoViewer._photoSphereRenderer._renderStereo = function (time, frame) {
          this.onXRFrame(time, frame);
        }.bind(this);

        this.panoViewer.enterVR({ requiredFeatures: ['local-floor'], optionalFeatures: ['local-floor'] }).then(function () {
          this.renderer = this.panoViewer._photoSphereRenderer;
          const vr = this.panoViewer._photoSphereRenderer._vr;
          if (vr === undefined) {
            return;
          }

          this.refSpace = vr._xrRefSpace;

          const gl = this.panoViewer._photoSphereRenderer.context;
          if (gl === undefined) { return; }

          this.xrSession = vr._xrSession;

          this.xrSession.addEventListener('select', this.onSelect.bind(this));

          this.xrScene = new Scene();

          this.renderer = new Renderer(gl);

          this.xrScene.setRenderer(this.renderer);

          // disable fps counter
          this.xrScene.enableStats(false);

          this.xrScene.inputRenderer.useProfileControllerMeshes(this.xrSession);

          this.scene.initXR(this.renderer, this.xrScene);
        }.bind(this), function (error) {
          alert(error);
        });
      } else { this.panoViewer.exitVR(); }

      this.vrMode = !this.vrMode;
    }

    onSelectStart () {}

    onSelectEnd () {}

    onSelect (ev) {
      if (this.xrScene == null) { return; }

      this.xrScene.handleSelect(ev.inputSource, ev.frame, this.refSpace);
    }

    onSqueezeStart () {}

    onSqueezeEnd () {}

    onSqueeze () {}

    isVrMode () {
      return this.vrMode;
    }

    // LOOK AT IS THE CULPRIT HERE
    lookAt (yaw, pitch, fov, duration, disableMove, shortest) { // Animate in shortest direction
      if (shortest !== false) {
        if (this.getYaw() - yaw > 180) { yaw += 360; } else if (yaw - this.getYaw() > 180) { yaw -= 360; }
      }

      if (duration > 0 && disableMove !== false) {
        this.disable();
        setTimeout(function () {
          this.enable();
        }.bind(this), duration);
      } else { this.enable(); }

      if (this.isHotspotClicked && !this.isEditing()) {
        this.panoViewer.lookAt({
          yaw: this.currentHotspotYaw,
          pitch: this.currentHotspotPitch,
          fov: fov || this.getFov()
        }, duration || 0);
        this.currentHotspotPitch = 0;
        this.currentHotspotYaw = 0;
        this.isHotspotClicked = false;
      } else {
        this.panoViewer.lookAt({
          yaw: yaw,
          pitch: pitch,
          fov: fov || this.getFov()
        }, duration || 0);
      }
    }

    // need to add a condition to see if its a hotspot that transition scene, or content display overlay
    lookAtOverlay (overlay, zoomFov, duration, isSceneTransition) {
      if (this.focusedOverlay === overlay) { // eslint-disable-next-line no-undef
        unFocus();
        return;
      }

      // this.contentView.openFrom(overlay.assetContainer);
      this.lookAt(overlay.getYaw(), -overlay.getPitch(), zoomFov, duration);
      this.panoViewer.setUseZoom(false);

      if (!isSceneTransition) {
        this.contentView.openFrom(overlay.assetContainer);
        this.container.addClass('ca-vr--showingcontent');

        setTimeout(function () {
          this.focusedOverlay = overlay;
        }.bind(this), Math.max(duration, 1000));
      }
    }

    unFocus () {
      if (!this.focusedOverlay) { return; }

      this.panoViewer.setUseZoom(true);
      this.focusedOverlay = null;
      this.lookAt(this.getYaw() + 8, this.getPitch(), 90, 600);
      this.container.removeClass('ca-vr--showingcontent');
      this.showControls(true);
      this.contentView.close();
      document.title = this.startTitle;
    }

    panBy (panAmount, duration) {
      this.lookAt(this.getYaw() + panAmount, this.getPitch(), this.getFov(), duration || 0);
    }

    zoomIn (duration, amount, disableMove) {
      this.lookAt(this.getYaw(), this.getPitch(), this.getFov() - (amount || VirtualRoom.ZOOM_INCREMENT), duration, disableMove);
    }

    zoomOut (duration, amount, disableMove) {
      this.lookAt(this.getYaw(), this.getPitch(), this.getFov() + (amount || VirtualRoom.ZOOM_INCREMENT), duration, disableMove);
    }

    enable () {
      this.container.removeClass('ca-vr_container--disabled');
      this.container.prop('disabled', false);
    }

    disable () {
      this.container.addClass('ca-vr_container--disabled');
      this.container.prop('disabled', true);
    }

    logAction (type, action) { // eslint-disable-next-line no-undef
      if (typeof _paq === 'function') { _paq.push(['trackEvent', type, action]); } else { console.log('Please include pwik thingy'); }
    }

    getRoomAssetPlaceholderCoords (roomId, placeholder) {
      let ret = null;
      const room = this.getRoomAsset(roomId);
      const placeholders = room.placeholders;

      jQuery.each(placeholders, function (i, p) {
        if (p.id === placeholder) {
          ret = p.coords;
          return false;
        }
      });

      return ret;
    }

    getBoardAsset (boardId) {
      let ret = null;
      jQuery.each(this.assets.boards, function (i, b) {
        if (b.id === boardId) {
          ret = b;
          return false;
        }
      });

      return ret;
    }

    getRoomAsset (roomId) {
      if (roomId === undefined) { roomId = this.getRoom(); }

      let ret = null;
      jQuery.each(this.assets.rooms, function (i, r) {
        if (r.id === roomId) {
          ret = r;
          return false;
        }
      });
      return ret;
    }

    setRoom (roomId) {
      this.options.room = roomId;
    }

    getRoom () {
      return this.options.room;
    }

    enableMove (moveEnabled) {
      this.moveEnabled = moveEnabled;

      if (!moveEnabled) {
        if (!this.lockedYaw) {
          this.lockedYaw = this.getYaw();
          this.lockedPitch = this.getPitch();
        }
        this.lookAt(this.lockedYaw, this.lockedPitch);
      } else {
        this.lockedYaw = null;
        this.lockedPitch = null;
      }
    }

    getYaw () {
      return this.panoViewer.getYaw();
    }

    getPitch () {
      return this.panoViewer.getPitch();
    }

    getFov () {
      return this.panoViewer.getFov();
    }

    getMaxFov () {
      return this.options.mobile ? 60 : 30;
    }

    getMinFov () {
      return 120;
    }

    getHFov () {
      const rect = this.container[0].getBoundingClientRect();
      const width = rect.width;
      const height = rect.height;
      return ((Math.atan((width / height) * Math.tan(this.toRadian(this.getFov()) / 2)) / Math.PI) * 360);
    }

    getTopLeftYawPitch () {
      return this.topLeftYawPitch;
    }

    getBottomRightYawPitch () {
      return this.bottomRightYawPitch;
    }

    isInView (yaw) {
      const inYaw = yaw >= this.topLeftYawPitch.yaw && yaw <= this.bottomRightYawPitch.yaw;
      return inYaw; // && inPitch;
    }

    toRadian (deg) {
      return (deg * Math.PI) / 180;
    }

    getFullscreenMethod () {
      return (document.body.requestFullScreen || document.body.webkitRequestFullScreen || document.body.mozRequestFullScreen || document.body.msRequestFullScreen);
    }

    getExitFullscreenMethod () {
      return (document.exitFullscreen || document.mozCancelFullScreen || document.webkitExitFullscreen || document.msExitFullscreen);
    }

    isFullscreenEnabled () {
      return this.getFullscreenMethod() != null;
    }

    addHotspot (yaw, stopAutoRotate) {
      if (stopAutoRotate) { this.stopAutoRotate(); }

      return this.scene.addHotspot({
        yaw: yaw || -this.getYaw()
      });
    }

    addNewHotspot (yaw, stopAutoRotate) {
      if (stopAutoRotate) { this.stopAutoRotate(); }

      return this.scene.addHotspot({
        yaw: yaw || -this.getYaw()
      }, true);
    }

    addPerson (yaw, stopAutoRotate) {
      if (stopAutoRotate) { this.stopAutoRotate(); }

      const person = this.scene.addPerson({
        yaw: yaw || -this.getYaw()
      });
      return person;
    }

    addBoard (yaw, stopAutoRotate) {
      if (stopAutoRotate) { this.stopAutoRotate(); }

      const board = this.scene.addBoard({
        yaw: yaw || -this.getYaw()
      });
      return board;
    }

    addCustomOverlay (yaw, stopAutoRotate) {
      if (stopAutoRotate) {
        this.stopAutoRotate();
      }
      const customOverlay = this.scene.addCustomOverlay({
        yaw: yaw || -this.getYaw()
      });
      return customOverlay;
    }

    removeAsset (obj) {
      this.scene.removeAsset(obj);
    }

    normalizeYaw (yaw) {
      let retYaw = yaw % 360;

      if (retYaw < 0) { retYaw += 360; }

      return retYaw;
    }

    normalizePitch (pitch) {
      let retPitch = pitch % 180;

      if (retPitch < 0) { retPitch += 180; }

      return retPitch;
    }

    yawPitchToPx (yaw, pitch, hfov) {
      const PI = Math.PI;
      const cos = Math.cos;
      const sin = Math.sin;
      const tan = Math.tan;

      // var canvasWidth = this.canvas[0].clientWidth, canvasHeight = this.canvas[0].clientHeight;

      const fov = ((hfov || this.getHFov()) * PI) / 180.0;

      const f = (0.5 * this.canvasWidth) / tan(0.5 * fov);

      const h = (yaw * PI) / 180.0;
      const p = (pitch * PI) / 180.0;

      const x = f * cos(p) * sin(h);
      const y = f * cos(p) * cos(h);
      const z = f * sin(p);

      const h0 = (-this.getYaw() * PI) / 180.0;
      const p0 = (this.getPitch() * PI) / 180.0;

      const x0 = f * cos(p0) * sin(h0);
      const y0 = f * cos(p0) * cos(h0);
      const z0 = f * sin(p0);

      //
      // Intersect the ray O, v = (x, y, z)
      // with the plane at M0 of normal n = (x0, y0, z0)
      //
      // n . (O + t v - M0) = 0
      // t n . v = n . M0 = f^2
      //
      const t = (f * f) / (x0 * x + y0 * y + z0 * z);

      const ux = sgn(cos(p0)) * cos(h0);
      const uy = -sgn(cos(p0)) * sin(h0);
      const uz = 0;

      const vx = -sin(p0) * sin(h0);
      const vy = -sin(p0) * cos(h0);
      const vz = cos(p0);

      const x1 = t * x;
      const y1 = t * y;
      const z1 = t * z;

      const dx10 = x1 - x0;
      const dy10 = y1 - y0;
      const dz10 = z1 - z0;

      // Project on the local basis (u, v) at M0
      const du = ux * dx10 + uy * dy10 + uz * dz10;
      const dv = vx * dx10 + vy * dy10 + vz * dz10;

      return {
        x: du + this.canvasWidth / 2,
        y: this.canvasHeight / 2 - dv
      };
    }

    mouseToYawPitch (event) { // var bounds = this.canvas[0].getBoundingClientRect();
      return this.pxToYawPitch(event.clientX || event.pageX, event.clientY || event.pageY);
    }

    openContent (content, callback) {
      this.showControls(false);
      this.showLoading('Loading...');

      this.contentView.setContent(content, () => {
        if (callback) { callback(); }

        this.hideLoading();
        if (content != null && content.heading != null) {
          document.title = content.heading + ' - ' + this.startTitle;
        }

        this.logAction('Popup', 'Opened content: ' + content.heading);
      });
    }

    pxToYawPitch (posX, posY, normalize) {
      const x = (posX / this.canvasWidth) * 2 - 1;
      const y = ((1 - (posY / this.canvasHeight) * 2) * this.canvasHeight) / this.canvasWidth;
      const focal = 1 / Math.tan((this.getHFov() * Math.PI) / 360);
      const s = Math.sin((this.getPitch() * Math.PI) / 180);
      const c = Math.cos((this.getPitch() * Math.PI) / 180);
      const a = focal * c - y * s;
      const root = Math.sqrt(x * x + a * a);
      const pitch = (Math.atan((y * c + focal * s) / root) * 180) / Math.PI;
      let yaw = (Math.atan2(x / root, a / root) * 180) / Math.PI - this.getYaw();
      if (yaw < -180) { yaw += 360; }

      if (yaw > 180) { yaw -= 360; }

      return {
        yaw: normalize ? this.normalizeYaw(yaw) : yaw,
        pitch: normalize ? this.normalizePitch(pitch) : pitch
      };
    }

    pxToYawPitchOld (u, v, normalize) {
      const rect = this.canvas[0].getBoundingClientRect();
      const pos = {};
      pos.x = u - rect.left;
      pos.y = v - rect.top;

      const PI = Math.PI;
      const cos = Math.cos;
      const sin = Math.sin;
      const tan = Math.tan;
      const sqrt = Math.sqrt;
      const atan2 = Math.atan2;
      const asin = Math.asin;

      const fov = (this.getHFov() * PI) / 180.0;

      const h0 = (this.getYaw() * PI) / 180.0;
      const p0 = (this.getPitch() * PI) / 180.0;

      const f = (0.5 * this.canvasWidth) / tan(0.5 * fov);

      const x0 = f * cos(p0) * sin(h0);
      const y0 = f * cos(p0) * cos(h0);
      const z0 = f * sin(p0);

      const du = pos.x - this.canvasWidth / 2;
      const dv = this.canvasHeight / 2 - pos.y;

      const ux = sgn(cos(p0)) * cos(h0);
      const uy = -sgn(cos(p0)) * sin(h0);
      const uz = 0;

      const vx = -sin(p0) * sin(h0);
      const vy = -sin(p0) * cos(h0);
      const vz = cos(p0);

      const x = x0 + du * ux + dv * vx;
      const y = y0 + du * uy + dv * vy;
      const z = z0 + du * uz + dv * vz;

      const R = sqrt(x * x + y * y + z * z);
      const h = atan2(x, y);
      const p = asin(z / R);

      return {
        yaw: normalize !== false
          ? this.normalizeYaw(
            (h * 180.0) / PI
          )
          : (h * 180.0) / PI,
        pitch: (p * 180.0) / PI
      };
    }

    injectStyles () {
      let styles = '';
      styles += '.ca-vr_control,.ca-ui-controlbutton{background-color:' + this.options.controlColor + '}';
      styles += '.ca-vr_control-group,.ca-ui_controlbuttongroup{background-color:' + this.options.controlColor + '}';
      styles += '.ca-vr_control:hover,.ca-ui-controlbutton:hover{background-color:' + this.options.controlHoverColor + '!important}';
      styles += '.ca-vr_hotspot_dot,.ca-ui-insetmap_hotspot.active{background-color:' + this.options.hotspotColor + ';color:' + this.options.hotspotTextColor + '}';
      styles += '.ca-ui-insetmap_hotspot{border-color:' + this.options.hotspotColor + '}';
      styles += '.ca-vr_hotspot span,.ca-dialog_mediahotspot_tooltip {background-color:' + this.options.hotspotTooltipColor + ';color:' + this.options.hotspotTooltipTextColor + '}';
      styles += '.ca-vr_hotspot.tooltip span:after,.ca-dialog_mediahotspot_tooltip:after{border-color:' + this.options.hotspotTooltipColor + ' transparent transparent transparent}';
      styles += '.ca-vr_fullpage .mfp-bg{background-color:' + this.options.modalBgColor + '}.ca-vr_fullpage .popup-header{background-color:' + this.options.modalHeadingColor + '}';
      styles += '.ca-vr_fullpage .btn-primary{background-color:' + this.options.modalHeadingColor + '}';
      styles += '.ca-dialog_beforeafter_buttons a.active{background-color:' + this.options.hotspotColor + '!important}';
      styles += '.ca-vr_slidebar_control{background-color:' + this.options.controlHoverColor + '!important}.ca-vr_playbutton i{color:' + this.options.controlHoverColor + '}';
      styles += '.ca-vr_playbutton:hover i{color:' + this.options.controlColor + '}';
      styles += '.ca-vr_container .pnlm-load-box .pnlm-lbar-fill{background: linear-gradient(45deg, ' + this.options.buttonPrimaryColor + '00, ' + this.options.buttonPrimaryColor + ');}';
      styles += '.ca-vr_load-ani{box-shadow: 88px 88px ' + this.options.buttonPrimaryColor + ', -88px 88px ' + this.options.buttonPrimaryColor + '94, -88px -88px ' + this.options.buttonPrimaryColor + ', 88px -88px ' + this.options.buttonPrimaryColor + '94}';
      styles += '@keyframes cssload-spin{0%,100% {box-shadow: 88px 88px ' + this.options.buttonPrimaryColor + ', -88px 88px ' + this.options.buttonPrimaryColor + '94, -88px -88px ' + this.options.buttonPrimaryColor + ', 88px -88px ' + this.options.buttonPrimaryColor + '94;}25% {box-shadow: -88px 88px ' + this.options.buttonPrimaryColor + '94, -88px -88px ' + this.options.buttonPrimaryColor + ', 88px -88px ' + this.options.buttonPrimaryColor + '94, 88px 88px ' + this.options.buttonPrimaryColor + ';}50% {box-shadow: -88px -88px ' + this.options.buttonPrimaryColor + ', 88px -88px ' + this.options.buttonPrimaryColor + '94, 88px 88px ' + this.options.buttonPrimaryColor + ', -88px 88px ' + this.options.buttonPrimaryColor + '94;}75% {box-shadow: 88px -88px ' + this.options.buttonPrimaryColor + 'ee, 88px 88px ' + this.options.buttonPrimaryColor + ', -88px 88px ' + this.options.buttonPrimaryColor + 'ee, -88px -88px ' + this.options.buttonPrimaryColor + ';}}';
      styles += '.ca-vr_hotspot_tooltip_top::after{border-color: ' + this.options.hotspotTooltipColor + ' transparent transparent transparent!important}';
      styles += '.ca-vr_hotspot_tooltip_right::after{border-color: transparent ' + this.options.hotspotTooltipColor + ' transparent transparent!important}';
      styles += '.ca-vr_hotspot_tooltip_bottom::after{border-color: ' + this.options.hotspotTooltipColor + ' transparent transparent transparent!important}';
      styles += '.ca-vr_hotspot_tooltip_left::after{border-color:' + this.options.hotspotTooltipColor + ' transparent transparent transparent!important}';
      styles += '.ca-vr_hotspot:hover .ca-vr_hotspot_tooltip_top::after{border-color: ' + this.options.hotspotTooltipHoverColor + ' transparent transparent transparent!important}';
      styles += '.ca-vr_hotspot:hover .ca-vr_hotspot_tooltip_right::after{border-color: transparent ' + this.options.hotspotTooltipHoverColor + ' transparent transparent!important}';
      styles += '.ca-vr_hotspot:hover .ca-vr_hotspot_tooltip_bottom::after{border-color: ' + this.options.hotspotTooltipHoverColor + ' transparent transparent transparent!important}';
      styles += '.ca-vr_hotspot:hover .ca-vr_hotspot_tooltip_left::after{border-color:' + this.options.hotspotTooltipHoverColor + ' transparent transparent transparent!important}';
      styles += '.ca-ui-loadspinner .circle{color:' + this.options.buttonPrimaryColor + '!important}';
      styles += '.ca-ui-vrwelcomepopup-enterbutton{background-color:' + this.options.buttonPrimaryColor + '}';
      styles += '.ca-ui-loadspinner .orbit{border-color:' + this.options.buttonPrimaryColor + '!important}';
      $('head').append('<style id="ca-vr-injectedstyles">' + styles + '</style>');
    }

    saveChanges () { // window.localStorage.setItem("ver_config", this.getJsonConfig());
    }

    getJsonConfig () {
      if (this.options.scenes === undefined) {
        this.options.scenes = [];
      }
      this.scenes.forEach(function (s, index) {
        this.options.scenes[index] = s.getJsonConfig();
      }.bind(this));
      return JSON.stringify(this.options, null, 2);
    }

    loadAssets (callback) {
      $.ajax(CAUI.basePath + '/assets/json/ver/3.0/assets.json').done(function (assets) {
        callback(assets);
      }).fail(function () {
        alert('error');
      });
    }

    saveLayoutTemplate () { // console.log(this.scene.saveLayoutTemplate());
    }

    loadLayoutTemplate (assets) {
      this.scene.loadLayoutTemplate(assets);
    }

    initTranslation () {
      $.getScript('//translate.google.com/translate_a/element.js?cb=VirtualRoom.initGoogleTranslation', () => {
        this.translateSelct = $('<div id="ca-vr_translate"></div>');
        this.translateSelct.hide();
        this.container.append(this.translateSelct);
      });
    }

    setRoomStatus (roomStatus) {
      this.options.status = roomStatus;
      console.log(this.options.status);
    }

    static initGoogleTranslation () { // eslint-disable-next-line no-new
      new google.translate.TranslateElement({
        pageLanguage: 'en',
        includedLanguages: 'ar,vi,zh-CN',
        layout: google.translate.TranslateElement.InlineLayout.SIMPLE
      }, 'ca-vr_translate');
    }

    addHotspotListMenu () {
      console.log('add hotspot list menu');
      const hotspotAndRegionEntries = this.getListOfHotspotEntriesAndInterestRegions();
      this.hotspotListMenu = $(`
        <div class='ca-ver_hotspot-list-menu'>
          <input type='checkbox' name='' id='' >
          <div class='ca-ver_hotspot-list-menu_button'>
            <span class="line line1"></span>
            <span class="line line2"></span>
            <span class="line line3"></span>
          </div>
          <ul class="menu">
            ${hotspotAndRegionEntries}
          </ul>
        </div>
        `);

      this.container.append(this.hotspotListMenu);

      const regionLinks = $('.ca-ver_hotspot-list-menu_region-link');
      for (let i = 0; i < regionLinks.length; i++) {
        $(regionLinks[i]).click(function () {
          const pitch = $(regionLinks[i]).attr('data-pitch');
          const yaw = $(regionLinks[i]).attr('data-yaw');
          this.goToInterestRegion(pitch, yaw);
        }.bind(this));
      }

      const hotspotLinks = $('.ca-ver_hotspot-list-menu_hotspot-link');
      for (let i = 0; i < hotspotLinks.length; i++) {
        $(hotspotLinks[i]).click(function () {
          const pitch = $(hotspotLinks[i]).attr('data-pitch');
          const yaw = $(hotspotLinks[i]).attr('data-yaw');
          const hotspotId = $(hotspotLinks[i]).attr('data-id');
          this.goToAndExecuteHotspot(hotspotId, pitch, yaw);
        }.bind(this));
      }

      this.hotspotListMenu.hide();

      if (!this.editor) {
        if (this.options.showHotspotList) {
          this.hotspotListMenu.show();
        }
      }
    }

    getListOfHotspotEntriesAndInterestRegions () {
      const regions = this.options.interestRegions;
      let regionList = '';
      if (regions) {
        regions.forEach(function (region) {
          console.log(region);

          const regionName = region.name;
          const regionYaw = region.location.yaw;
          const regionPitch = region.location.pitch;
          const regionEntry = `<li><a data-pitch=${regionPitch} data-yaw=${regionYaw} class='ca-ver_hotspot-list-menu_region-link'>${regionName}</a></li>`;
          regionList = regionList + regionEntry;
          if (region.hotspots) {
            region.hotspots.forEach(function (hotspot) {
              console.log(hotspot);
              const hotspotIcon = hotspot.icon;
              const hotspotName = hotspot.name;
              const hotspotYaw = hotspot.yaw;
              const hotspotPitch = hotspot.pitch;
              const hotspotId = hotspot.id;
              const hotspotEntry = `<li><i class="fa">&#xf${hotspotIcon}</i><a class='ca-ver_hotspot-list-menu_hotspot-link' data-id=${hotspotId} data-pitch=${hotspotPitch} data-yaw=${hotspotYaw}>${hotspotName}</a></li>`;
              regionList = regionList + hotspotEntry;
            });
          }
        });
        return regionList;
      }
      return regionList;
    }

    goToAndExecuteHotspot (_hotspotId, _pitch, _yaw) {
      let hotspotToTarget;
      this.scene.hotspots.forEach((hotspot) => {
        if (hotspot.options.id === _hotspotId) {
          hotspotToTarget = hotspot;
        }
      });
      console.log(hotspotToTarget);
      // we need to uncheck the input hotspot list button
      $('.ca-ver_hotspot-list-menu input[type="checkbox"]').trigger('click');

      // we need to move to the hotspot itself
      this.panoViewer.lookAt({ pitch: hotspotToTarget.topLeftYawPitch.pitch, yaw: -hotspotToTarget.topLeftYawPitch.yaw }, 1000);

      // then we need to execute its action
      if (hotspotToTarget.options.action) {
        console.log($(hotspotToTarget.actionLink[0].children[0]));
        $(hotspotToTarget.actionLink[0].children[0]).trigger('click');
      }
    }

    addTopBarInterestRegionMenu () {
      console.log('add top bar menu');
      const interestRegions = this.getInterestRegions();
      console.log(interestRegions);
      this.topBarInterestRegionsMenu = $(`
        <div class='ca-ver_interest-regions-menu'>
          <ul class="menu">
            ${interestRegions}
          </ul>
        </div>
        `);

      this.container.append(this.topBarInterestRegionsMenu);

      const menuLinks = $('.ca-ver_interest-regions-menu_item-link');
      for (let i = 0; i < menuLinks.length; i++) {
        $(menuLinks[i]).click(function () {
          const pitch = $(menuLinks[i]).attr('data-pitch');
          const yaw = $(menuLinks[i]).attr('data-yaw');
          $('.ca-ver_interest-regions-menu li').removeClass('selected');
          $(menuLinks[i]).parent().addClass('selected');
          this.goToInterestRegion(pitch, yaw);
        }.bind(this));
      }

      this.topBarInterestRegionsMenu.hide();

      if (!this.editor) {
        if (this.options.showTopBar) {
          this.topBarInterestRegionsMenu.show();
        }
      }
    }

    goToInterestRegion (pitch, yaw) {
      console.log('go to interest region');
      this.panoViewer.lookAt({ pitch: pitch, yaw: yaw }, 1000);
    }

    getInterestRegions () {
      if (this.options.interestRegions) {
        const interestRegions = this.options.interestRegions;
        let interestRegionsList = '';

        interestRegions.forEach(function (interestRegion) {
          const pitch = interestRegion.location.pitch;
          const yaw = interestRegion.location.yaw;
          const label = interestRegion.name;
          const interestRegionEntry = `<li><a class='ca-ver_interest-regions-menu_item-link' data-pitch=${pitch} data-yaw=${yaw}>${label}</a></li>`;
          interestRegionsList = interestRegionsList + interestRegionEntry;
        });
        return interestRegionsList;
      } else {
        return null;
      }
    }
}

function sgn (x) {
  return x >= 0 ? 1 : -1;
}
